import { render, staticRenderFns } from "./IconFolderAddOutline.vue?vue&type=template&id=268eeb8f"
import script from "./IconFolderAddOutline.vue?vue&type=script&lang=js"
export * from "./IconFolderAddOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports